import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const updateTopic = createAsyncThunk('updateTopic', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'topic',
            data: {
                "id": data?.values?.id,
                "institute_id": data?.values?.instituteId,
                "subject_id": data?.values?.subjectId,
                "course_id": data?.values?.courseId,
                "topic_name": data?.values?.topicName,
                "description": data?.values?.description,
                "status": data?.values?.status
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})
